module.exports = __webpack_public_path__ + "static/person-placeholder-6d538f72bbd5a17f2f1bb26cdb2f0966.jpg";